'use client';

import { useParams } from 'next/navigation';

import { CategoriesSwiper } from '@/components';
import { useCategories } from '@/hooks';
import { routes } from '@/statics';

type RouteParams = {
  category: string;
  subcategory: string;
};
const SubCategories: React.FC = () => {
  const { category, subcategory } = useParams<RouteParams>();
  const { data: categoriesData } = useCategories();
  const categories = categoriesData?.filter(
    (item) => item.parent_code === Number(category)
  );

  return (
    <>
      {categories && (
        <CategoriesSwiper
          categories={categories}
          hrefCreator={(categoryCode: number) =>
            routes.subCategory.href(Number(category), categoryCode)
          }
          initialSelectedCategory={Number(subcategory)}
        />
      )}
    </>
  );
};
export default SubCategories;
